/**
 * Maps keyboard characters to event key codes.
 */
export const eventKeyCodes = {
  enter: 13,
  escape: 27,
  space: 32
};